import React from 'react';
import i18n from '@i18n';
import useLocalStorage from 'nike-ui/src/common/hooks/useLocalStorage';
import { Box } from '@/common/components/layout/Box';
import { Color } from '@/common/Color';
import { InfoPaper } from '@/common/components/surfaces/Paper';
import { fireGAEvent } from '@/analytics';

export function FavoritesInfo() {
    const [favoritesInfo, setFavoritesInfo] = useLocalStorage('favoritesInfo', 'showed');
    function hideFavoritesInfo(e) {
        e.stopPropagation();
        fireGAEvent('Nastavenia', 'Skryt informaciu o oblubenych');
        setFavoritesInfo('hidden');
    }
    return favoritesInfo === 'showed' ? (
        <Box padding={20} bgColor={Color.paleGray}>
            <InfoPaper closeAction={hideFavoritesInfo}>{i18n('footnote.favorites.text')}</InfoPaper>
        </Box>
    ) : null;
}
